var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body bg-cl-3c3f72 pd-sticky"},[_vm._m(0),_c('app-list',{attrs:{"apps":_vm.apps}}),_c('the-footer',{attrs:{"divide":2,"first-button":{
      isPlain: true,
      class: 'align-left',
      classList: 'btn-icon btn-white',
      trigger: {
        function: 'moveTo',
        argument: -1
      },
      text: 'Previous'
    },"second-button":{
      isPlain: false,
      type: 'success',
      class: 'align-right',
      classList: 'btn-icon btn-success',
      trigger: {
        function: 'goTo',
        argument: _vm.homePage
      },
      text: 'Go to dashboard'
    }},on:{"moveTo":function($event){return _vm.moveTo($event)},"goTo":function($event){return _vm.goTo($event)}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header",staticStyle:{"padding":"0 15px"}},[_c('p',{staticClass:"align-left cl-ffffff"},[_vm._v(" Recommended Apps ")])])}]

export { render, staticRenderFns }